import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Grid from '@mui/material/Grid';
import Popper from '@mui/material/Popper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import IconButton from '@mui/material/IconButton';

import {
    X as XIcon,
    Facebook as FacebookIcon,
    WhatsApp as WhatsAppIcon,
    Email as EmailIcon,
    Telegram as TelegramIcon,
} from '@mui/icons-material';

import CommonImages from '../../../commons/images';

import { useStyles } from './styles';
 
function ShareDialog (props) {
    const {
        open = false,
        anchorEl = null,
        onClose = () => {},
        onShare = () => {},
    } = props;

    const classes = useStyles();

    return (
        <Popper
            data-ecal-id="share-dialog"
            open={open}
            anchorEl={anchorEl}
            placement={'bottom'}
            className={classes.popper}
        >  
            <ClickAwayListener onClickAway={() => onClose()}>
                <Grid className={classes.root}>
                    <Grid className={classes.menuTail}>
                        <img
                            src={CommonImages.DIALOG_TAIL}
                            className={classes.menuTailImg}
                            alt="tail"
                        />
                    </Grid>
                    <Grid className={classes.rootBody}>
                        <Grid className={classes.iconsParent}>
                            <IconButton
                                data-ecal-id="share-twitter"
                                aria-label="twitter"
                                className={classNames([classes.icon, classes.iconSpace])}
                                onClick={() => {onShare('twitter')}}
                            >
                                <XIcon className={classes.iconX}/>
                            </IconButton>

                            <IconButton
                                data-ecal-id="share-facebook"
                                aria-label="facebook"
                                className={classNames([classes.icon, classes.iconSpace])}
                                onClick={() => {onShare('facebook')}}
                            >
                                <FacebookIcon />
                            </IconButton>

                            <IconButton
                                data-ecal-id="share-whatsapp"
                                aria-label="whats app"
                                className={classNames([classes.icon, classes.iconSpace])}
                                onClick={() => {onShare('whatsapp')}}
                            >
                                <WhatsAppIcon />
                            </IconButton>

                            <IconButton
                                data-ecal-id="share-email"
                                aria-label="email"
                                className={classNames([classes.icon, classes.iconSpace])}
                                onClick={() => {onShare('email')}}
                            >
                                <EmailIcon />
                            </IconButton>

                            <IconButton
                                data-ecal-id="share-telegram"
                                aria-label="settings"
                                className={classNames([classes.icon])}
                                onClick={() => {onShare('telegram')}}
                            >
                                <TelegramIcon />
                            </IconButton>

                        </Grid>
                    </Grid> 
               </Grid>
            </ClickAwayListener>
        </Popper>
    );
}

ShareDialog.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    anchorEl: PropTypes.any,
    onShare: PropTypes.func,
};

export default ShareDialog;